export default "__VITE_ASSET__DKDSL8to__"